import {scroll} from "./scroll.js";

export const appears = (...selector) => {
    const selectors = selector.join(',');

    const elements = document.querySelectorAll(selectors);

    if (elements.length > 0)  {
      scroll(
        scrollY => {
          appear_apply(elements);
        }
      )
    }
}
export const appear_apply = (elements, force = false) =>
{

    elements.forEach((el) => {
        const defaultOffset = window.innerHeight / 10;

        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const dataOffset = (el.getAttribute('data-offset')) ? (el.getAttribute('data-offset')) : defaultOffset;
        let offset = 0;
        if (typeof dataOffset == 'string' && dataOffset.endsWith('%')) {
            const pourcent = parseInt(dataOffset.replace('%','')) / 100;
            offset = windowHeight*pourcent;
        } else {
            offset = parseInt(dataOffset);
        }

        const once = el.hasAttribute('appear-once');

        if (!el.classList.contains('appear')) {
            if ( enterViewport(el, offset)) {
                el.classList.add('appear')

                el.dispatchEvent(new CustomEvent('appear', {
                    detail: {
                        target: el,
                        trigger: 'enterViewport',
                    },
                }));
            }
        } else if (once !== true && hasLeaveViewport(el, offset)) {
            //el.classList.remove('appear')
        }
    });
}

const enterViewport = (el, offset) =>
{
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const rect = el.getBoundingClientRect();
    return (
   // ((rect.top + offset) <= windowHeight || rect.bottom+offset <= windowHeight) && rect.bottom > 0
    ((rect.top + offset) <= windowHeight )
  );
}

const willLeaveViewport=(el, offset) =>
{
    const rect = el.getBoundingClientRect();

    return (
    (rect.top - offset) < 0 /* or $(window).height() */
  );
}

const hasLeaveViewport = (el, offset) =>
{
    const rect = el.getBoundingClientRect();

    return (
    (rect.bottom - offset) < 0
  );
}

const themeCheck = (el) =>
{
    const rect = el.getBoundingClientRect();

    return (rect.top < 100 && rect.bottom > 100)
}
